// Remembers the browser's time zone in a readable cookie so the server can
// show dates in local time (ApplicationController#use_visitor_time_zone).
export function rememberTimeZone(doc: Document = document): void {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (zone && !doc.cookie.includes(`tz=${encodeURIComponent(zone)}`)) {
      doc.cookie = `tz=${encodeURIComponent(zone)}; path=/; max-age=31536000; samesite=lax`
    }
  } catch {
    // Old browsers: dates stay in UTC.
  }
}
